/*
 * File: VitalsFields.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Defines the fields used in the Create Vitals form, these are passed to FormBuilder to create the form
 */
const VitalsFields = [
  {
    name: "date",
    label: "Time Measured",
    type: "datetime"
  },
  {
    name: "weight",
    label: "Weight (lbs)",
    type: "decimal",
    htmlInputProps: {
      //The max allowed in the database after converting to grams.
      max: "4734394"
    }
  },
  {
    name: "feet",
    label: "Height (ft)",
    type: "integer",
    gridItemProps: { xs: 6, sm: 6 },
    htmlInputProps: {
      max: "99999"
    }
  },
  {
    name: "inches",
    label: "(in)",
    type: "decimal",
    gridItemProps: { xs: 6, sm: 6 },
    htmlInputProps: {
      max: "11"
    }
  },
  {
    name: "systolic",
    label: "Systolic (mmHg)",
    type: "integer",
    gridItemProps: { xs: 6, sm: 6 },
    htmlInputProps: {
      max: "2147483647"
    }
  },
  {
    name: "diastolic",
    label: "Diastolic (mmHg)",
    type: "integer",
    gridItemProps: { xs: 6, sm: 6 },
    htmlInputProps: {
      max: "2147483647"
    }
  },
  {
    name: "temperature",
    label: "Temperature (°F)",
    type: "decimal",
    htmlInputProps: {
      max: "200",
      decimalScale: 1
    }
  },
  {
    name: "heartRate",
    label: "Heart Rate (BPM)",
    type: "integer",
    htmlInputProps: {
      max: "2147483647"
    }
  },
  {
    name: "sp02",
    label: "Sp O2 (%)",
    type: "decimal",
    htmlInputProps: {
      max: "100",
      decimalScale: 1
    }
  },
  {
    name: "respiratoryRate",
    label: "Respiratory Rate (Breaths/Min)",
    type: "integer",
    htmlInputProps: {
      max: "2147483647"
    }
  }
];

export default VitalsFields;
